import React from 'react'
import { cn } from '@/utilities/ui'

/**
 * Renders the Civo wordmark as a CSS mask filled with an arbitrary colour, so
 * we can recolour / outline / distort the mark for the "don'ts" illustrations
 * without shipping a bespoke asset per misuse. Decorative only (aria-hidden).
 */
export const MaskedLogo: React.FC<{
  src?: string
  color?: string
  className?: string
  style?: React.CSSProperties
}> = ({ src = '/assets-rebrand/logos/civo-black.svg', color = '#000000', className, style }) => (
  <span
    aria-hidden="true"
    className={cn('inline-block', className)}
    style={{
      backgroundColor: color,
      WebkitMaskImage: `url(${src})`,
      maskImage: `url(${src})`,
      WebkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      maskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskSize: 'contain',
      ...style,
    }}
  />
)
